export const bindClassMethods = (classInstance) => {
    const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(classInstance));
    methods
        .filter((method) => method !== "constructor")
        .forEach((method) => {
        classInstance[method] = classInstance[method].bind(classInstance);
    });
};
export const debounce = (waitMillis, callback) => {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), waitMillis);
    };
};
export const hasScrollReachedBottom = (element, offset = 1) => {
    return element.scrollHeight - element.scrollTop - element.clientHeight < offset;
};
export const getParameterValue = (param) => {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
};
export const isScrollable = (element) => {
    const overflowY = window.getComputedStyle(element)["overflow-y"];
    const overflowX = window.getComputedStyle(element)["overflow-x"];
    return {
        vertical: (overflowY === "scroll" || overflowY === "auto") &&
            element.scrollHeight > element.clientHeight,
        horizontal: (overflowX === "scroll" || overflowX === "auto") &&
            element.scrollWidth > element.clientWidth,
    };
};
export const isHidden = (element) => {
    const style = window.getComputedStyle(element);
    return (style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0' ||
        (element.offsetWidth === 0 && element.offsetHeight === 0));
};
